// extracted by mini-css-extract-plugin
module.exports = {"container":"src-components-HeaderDropdown-index-module__container--2IVT_"};